module.exports = __webpack_public_path__ + "img/furniture-active-icon.04b748f9.svg";